/**
 * Keeps Symmetry's --theme-header-height / --theme-sticky-header-height in
 * sync with the Silverstein (Dawn) header that replaced Symmetry's own.
 *
 * Symmetry set these from its <page-header> element. That element is gone, but
 * the templates it did not migrate still read the variables — `.height--full`
 * sizes itself with calc(100vh - var(--theme-sticky-header-height)), and the
 * FAQ index, sticky sidebars and the collection utility bar offset themselves
 * by it. An unset variable makes those calc() declarations invalid and they
 * are dropped, so the values are republished here from the Dawn header.
 */
(function () {
  const root = document.documentElement;
  let header = null;

  function apply() {
    header = header || document.querySelector('.section-header');
    if (!header) return;

    // getBoundingClientRect over offsetHeight: Dawn's sticky header is
    // translated out of view on scroll-down, and translation must not change
    // the reported height.
    const height = Math.ceil(header.getBoundingClientRect().height);
    const position = getComputedStyle(header).position;
    const sticky = position === 'sticky' || position === '-webkit-sticky';

    root.style.setProperty('--theme-header-height', `${height}px`);
    root.style.setProperty('--theme-sticky-header-height', sticky ? `${height}px` : '0px');
  }

  function watch() {
    apply();
    if (!header) return;
    if ('ResizeObserver' in window) {
      new ResizeObserver(apply).observe(header);
    } else {
      window.addEventListener('resize', apply);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch, { once: true });
  } else {
    watch();
  }

  // The header re-renders when it is edited in the theme editor.
  document.addEventListener('shopify:section:load', () => {
    header = null;
    watch();
  });
})();
